export default "__VITE_ASSET__A_E9nN8p__"